import React from "react";

import Circle from "./CircleProgress";
import { Button, Typography } from "@mui/material";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import Divider from '@mui/material/Divider';
import * as util from "../utils/util";
import BeenhereIcon from "@mui/icons-material/Beenhere";


const HistoryInputCard = (props: any) => {

  React.useEffect(() => {
  }, []);

  return (
    <Box alignItems="flex-start" sx={Card_Style} >
      {props.healthInfo.target <= props.healthInfo.kcal ? (
        <BeenhereIcon sx={{ fontSize: 40, position: 'absolute', color: '#007e05de' }} />
      ) : (
        null
      )}
      <Typography sx={{ textAlign: 'center', fontSize: 14, fontWeight: 700, p: '15px 0 15px 0' }}> {props.healthInfo.title} </Typography>
      <Divider />
      <Box sx={{ p: 0.5 }}>
        <Stack justifyContent={'center'} alignItems={'center'}>
          <Box>
            <Circle progress={{ goal: props.healthInfo.target, value: props.healthInfo.kcal }} />
          </Box>
          <Box sx={{ pb: 1 }}>
            <Button onClick={props.healthInfo.navi} sx={{ flexWrap: 'wrap', p: 0 }}>
              <Stack direction={'row'} alignItems={'baseline'}>
                <Typography sx={{ color: '#555', fontSize: 22, pr: '5px', fontWeight: 700 }}>{util.formatComma(props.healthInfo.kcal)}</Typography>
                <Typography sx={{ color: '#888', fontSize: 14, textTransform: 'none' }}>{props.healthInfo.unitType} </Typography>
              </Stack>
            </Button>
          </Box>
          <Box sx={{ pb: 2 }}>
            <Button onClick={props.healthInfo.navi} sx={{  p: 0, border:'1px solid #EF8322', borderRadius:5 }}>
              <EditNoteRoundedIcon sx={{ ml: 1, color: '#EF8322' }} />
                <Typography sx={{ color: '#EF8322', fontSize: 14, pr:1, fontWeight: 700, pl:.5 }}>입력하기</Typography>
            </Button>
          </Box>
        </Stack>
        <Divider />
        <Box sx={{ p: 0.5 }}>
          <Typography sx={{ fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', height: 32, color: '#555' }}> {props.healthInfo.infoText}</Typography>
        </Box>
      </Box>

      <BorderLinearProgress variant="determinate" value={props.healthInfo.kcal / props.healthInfo.target * 100 >= 100 ? 100 : props.healthInfo.kcal / props.healthInfo.target * 100}
        sx={{ borderRadius: '0 0 20px 20px', bgcolor: '#eaeaea' }}
      />
    </Box>
  );
  {/* <ListItem alignItems="flex-start" sx={Card_Style} >
          <ListItemAvatar>
              <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
          </ListItemAvatar>
          <ListItemText
          primary ={title} 
          secondary={
              <Box>
                  <Box>{props.values.kcal} {props.values.unitType} 
                      <Button onClick={props.values.navi}>
                          <ModeIcon />
                      </Button>
                  </Box>
                  {props.values.emptyText}
                  <LinearProgress variant="determinate" value={progress} />
              </Box>
          }
          >
          </ListItemText>
      </ListItem> 
  );*/}
}

const BorderLinearProgress = styled(LinearProgress)({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#eaeaea',
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: '#EF8322',
  },
});

const Card_Style = {
  borderRadius: '10px',
  background: '#fff',
  boxShadow: '0 0 6px  rgba(0,0,0,0.2)',

  flex: '0 50%',
  maxWidth: '100%'
};

export default HistoryInputCard;